import { HostBinding, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {CustomerIntegrationType} from '../../../../../customer-integration/customer-integration';
import {ConfigurationLoader} from 'shared/configuration-loader';

@Component({
  selector: 'app-kids-catalog-toggle',
  templateUrl: './kids-catalog-toggle.component.html'
})
export class KidsCatalogToggleComponent implements OnInit {
  @Output() public onExpandToggle = new EventEmitter();
  @Output() public closeFilterPanel = new EventEmitter();
  @Input() public expanded: boolean;
  @Input() public fullscreen: boolean;
  public isNlbCustomer: boolean;

  constructor(private configLoader: ConfigurationLoader) { }

  public ngOnInit() {
    this.isNlbCustomer = this.configLoader.customerIntegrationType === CustomerIntegrationType.NLB;
  }

  @HostBinding('class.kids-catalog-toggle-container')

  public expandToggle(value: boolean) {
    this.onExpandToggle.emit(value);
  }

  public closePanel() {
    this.closeFilterPanel.emit();
  }

}
